/**
 * @generated SignedSource<<ea1719c620d902314223b729a6a26570>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskCopilotPanelSendMessageViaNoteMutation$variables = {
  content: string;
  contentForDisplay?: string | null;
  messageId?: string | null;
  noteId: string;
};
export type AskCopilotPanelSendMessageViaNoteMutation$data = {
  readonly askCopilotSendNoteMessage: {
    readonly note: {
      readonly askCopilotConversation: {
        readonly " $fragmentSpreads": FragmentRefs<"AskCopilotPanelFragment">;
      } | null;
    };
  } | null;
};
export type AskCopilotPanelSendMessageViaNoteMutation = {
  response: AskCopilotPanelSendMessageViaNoteMutation$data;
  variables: AskCopilotPanelSendMessageViaNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentForDisplay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "messageId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "content",
    "variableName": "content"
  },
  {
    "kind": "Variable",
    "name": "contentForDisplay",
    "variableName": "contentForDisplay"
  },
  {
    "kind": "Variable",
    "name": "messageId",
    "variableName": "messageId"
  },
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentForDisplay",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AskCopilotPanelSendMessageViaNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AskCopilotSendNoteMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendNoteMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotConversation",
                "kind": "LinkedField",
                "name": "askCopilotConversation",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskCopilotPanelFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AskCopilotPanelSendMessageViaNoteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AskCopilotSendNoteMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendNoteMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotConversation",
                "kind": "LinkedField",
                "name": "askCopilotConversation",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AskCopilotMessage",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "role",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentJson",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pending",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isResponse",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userRating",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SuggestedQuestion",
                    "kind": "LinkedField",
                    "name": "suggestedQuestions",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reachedMessageLimit",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3b7400ca87a5bba092a8d3791491293",
    "id": null,
    "metadata": {},
    "name": "AskCopilotPanelSendMessageViaNoteMutation",
    "operationKind": "mutation",
    "text": "mutation AskCopilotPanelSendMessageViaNoteMutation(\n  $noteId: ID!\n  $content: String!\n  $messageId: String\n  $contentForDisplay: String\n) {\n  askCopilotSendNoteMessage(content: $content, noteId: $noteId, messageId: $messageId, contentForDisplay: $contentForDisplay) {\n    note {\n      askCopilotConversation {\n        ...AskCopilotPanelFragment\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment AskCopilotPanelFragment on AskCopilotConversation {\n  id\n  messages {\n    id\n    role\n    content\n    contentJson\n    pending\n    createdAt\n    isResponse\n    contentForDisplay\n    ...AskCopilotPanel_groupToolUsesWithResponse_message\n    ...AskCopilotPanel_ToolUseAndResult_use\n    ...AskCopilotPanel_ToolUseAndResult_result\n    ...AskCopilotPanel_ChatMessage_message\n  }\n  suggestedQuestions {\n    id\n    ...AskCopilotPanel_SuggestedQuestionButton_suggestedQuestion\n  }\n  reachedMessageLimit\n}\n\nfragment AskCopilotPanel_ChatMessage_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentJson\n  contentForDisplay\n  pending\n  isResponse\n  ...AskCopilotPanel_ToolUseAndResult_use\n  ...AskCopilotPanel_RatingButtons_message\n}\n\nfragment AskCopilotPanel_RatingButtons_message on AskCopilotMessage {\n  id\n  userRating\n}\n\nfragment AskCopilotPanel_SuggestedQuestionButton_suggestedQuestion on SuggestedQuestion {\n  id\n  content\n  contentForDisplay\n}\n\nfragment AskCopilotPanel_ToolUseAndResult_result on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskCopilotPanel_ToolUseAndResult_use on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskCopilotPanel_groupToolUsesWithResponse_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentForDisplay\n  contentJson\n}\n"
  }
};
})();

(node as any).hash = "998a1943c8db42d23a84291c87affe3a";

export default node;
